<template lang="pug">
  el-menu-item(index='/sites')
    .img-wrapper
      img(src="@src/assets/sidebar/cost_centers.svg")
    router-link.sub-menu-link(to="/sites")
      span  {{ $t('sidebar.sites') }}
</template>

<script>
import { general } from "@src/services/dynamicViews/general";
import { mapState } from "vuex";


export default {
  name: "SitesItem",
  mixins: [general],

  computed: {
    ...mapState("auth", ["user"]),
  },
}
</script>
